window.LoadingSpinner = class LoadingSpinner {
	constructor(containerId = 'PageContainer') {
	  this.container = document.getElementById(containerId);
	  if (!this.container) {
		console.error(`Không tìm thấy element có id '${containerId}'.`);
	  }
	  this.overlay = null;
	  this.handleKeyDown = this.handleKeyDown.bind(this);
	}
	show() {
	  if (!this.container) return;
	  if (this.container.querySelector('#loading-spinner')) return;

	  requestAnimationFrame(() => {
		if (!this.container) return;
		if (this.container.querySelector('#loading-spinner')) return;
  
		this.overlay = document.createElement('div');
		this.overlay.classList.add('loading-overlay');
		const spinner = document.createElement('div');
		spinner.id = 'loading-spinner';
		spinner.classList.add('loyalty-loading-spinner');
		this.overlay.appendChild(spinner);
		this.container.appendChild(this.overlay);
		document.documentElement.classList.add('no-loading-scroll');
		document.addEventListener('keydown', this.handleKeyDown);
	  });
	}
	hide() {
	  requestAnimationFrame(() => {
		const overlay = this.overlay || this.container?.querySelector('.loading-overlay');
		if (overlay && this.overlay.parentNode) {
		  document.removeEventListener('keydown', this.handleKeyDown);
		  document.documentElement.classList.remove('no-loading-scroll');
		  overlay.parentNode.removeChild(overlay);
		  this.overlay = null;
		}
	  });
	}
	handleKeyDown(event) {
	  event.preventDefault();
	}
  };